<template>
<div class="modal_wrapper">
  <div class='container'>
    <div class='modal_container'>
      <div class="modal_header">
        <img :src='caution' height=25px>
        {{confirm}}
      </div>
      <div class="modal_body">
        <div class="body" v-html='question'>
        </div>
        <div class="modal_buttons">
          <input type=button :value='cancelButton' class="cancel_button" @click="$emit('close')">
          <input type=button :value='okButton' class="finish_button" @click="$emit('ok')">
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: ['question'],
  data () {
    return {
      caution: require('../../img/caution.png'),
      confirm: '確認',
      cancelButton: 'キャンセル',
      okButton: 'OK'
    }
  }
}
</script>
<style scoped>
.modal_wrapper {
  background-color: rgba(0, 0, 0, .5);
}
.container {
  display: table-cell;
  vertical-align: middle;
}
.body {
  width: 100%;
  height: 117px;
  padding-top: 40px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/modalWindow/confirmModalWindow.vue